import { render, staticRenderFns } from "./class-society-selector.vue?vue&type=template&id=07e62622&"
import script from "./class-society-selector.vue?vue&type=script&lang=js&"
export * from "./class-society-selector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports